import type { Language } from './Language';
import { getCurrentLanguage } from './translationUtils';

export const LANGUAGE_KEYS_MODE_URL_PARAM = 'languageKeysMode';
const LANGUAGE_QUERY_PARAMETER_KEY = 'lang';

export function getNormalizedLanguage(
    allowedLanguages: Language[],
    language: Language | string | null | undefined,
): Language | null {
    if (!language) {
        return null;
    }
    const myLanguage = language.toLowerCase() as Language;
    if (!allowedLanguages.includes(myLanguage)) {
        return null;
    }

    return myLanguage;
}

export function getQueryLanguage(allowedLanguages: Language[]): Language | null {
    return getNormalizedLanguage(
        allowedLanguages,
        new URLSearchParams(window.location.search)?.get(LANGUAGE_QUERY_PARAMETER_KEY),
    );
}

export function isLanguageKeysModeActive(): boolean {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(LANGUAGE_KEYS_MODE_URL_PARAM) === 'true';
}

export function changeLanguage(language: Language): void {
    if (language === getCurrentLanguage()) {
        return;
    }

    const params = new URLSearchParams(window.location.search);
    params.set(LANGUAGE_QUERY_PARAMETER_KEY, language);
    window.location.search = params.toString();
}
